(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ge-contact"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var NL = String.fromCharCode(10);

    function field(form, id) {
      var el = form.querySelector('#' + id);
      return el ? String(el.value || '').trim() : '';
    }

    function buildPayload(form) {
      var subject = form.querySelector('.ge-contact__pills input:checked');
      var activity = field(form, 'GeQuote-type');
      var lines = [];
      if (subject) lines.push('Objet : ' + subject.value);
      if (activity) lines.push('Activité : ' + activity);
      var message = field(form, 'GeQuote-body');
      if (message) lines.push('', message);
      return {
        version: 2,
        source: {
          type: 'shopify_contact_page',
          shop: (window.Shopify && window.Shopify.shop) || window.location.hostname,
          page_url: window.location.href,
          user_agent: navigator.userAgent,
          submitted_at: new Date().toISOString()
        },
        company: { name: field(form, 'GeQuote-company'), type: activity },
        contact: {
          name: field(form, 'GeQuote-name'),
          email: field(form, 'GeQuote-email'),
          phone: field(form, 'GeQuote-phone')
        },
        event: { date: field(form, 'GeQuote-date'), location: field(form, 'GeQuote-location') },
        message: lines.join(NL)
      };
    }

    function prefill(form) {
      var params = new URLSearchParams(window.location.search);
      var body = document.getElementById('GeQuote-body');
      var produit = params.get('produit');
      if (produit && body && !body.value) {
        body.value = ['Bonjour, je souhaite recevoir un devis pour : ' + produit, 'Quantité souhaitée : ', ''].join(NL);
      }
      var objet = (params.get('objet') || '').toLowerCase();
      if (objet) {
        form.querySelectorAll('.ge-contact__pills input').forEach(function (input) {
          if (input.value.toLowerCase().indexOf(objet) !== -1) input.checked = true;
        });
      }
    }

    function init() {
      var form = document.getElementById('GeQuoteForm');
      if (!form) return;
      prefill(form);
      var wrap = form.closest('[data-crm-url]');
      var crmUrl = wrap ? wrap.getAttribute('data-crm-url') : '';
      if (!crmUrl) return;

      form.addEventListener('submit', function (event) {
        if (form.getAttribute('data-ge-sent') === '1') return;
        var trap = form.querySelector('[name="ge_hp"]');
        if (trap && trap.value) return;
        event.preventDefault();

        var button = form.querySelector('[type="submit"]');
        if (button) {
          button.disabled = true;
          button.classList.add('is-loading');
          var label = button.querySelector('.ge-contact__submit-label');
          var wait = button.querySelector('.ge-contact__submit-wait');
          if (label && wait) { label.hidden = true; wait.hidden = false; }
        }

        var done = false;
        function sendToShopify() {
          if (done) return;
          done = true;
          form.setAttribute('data-ge-sent', '1');
          HTMLFormElement.prototype.submit.call(form);
        }

        try {
          fetch(crmUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-GE-Source': 'shopify-contact-page' },
            body: JSON.stringify(buildPayload(form)),
            mode: 'cors',
            credentials: 'omit'
          }).then(sendToShopify, sendToShopify);
        } catch (error) {
          sendToShopify();
        }
        setTimeout(sendToShopify, 6000);
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ge-delivery-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      document.querySelectorAll('.ge-dlhero__checker').forEach(function (box) {
        var zone = (box.getAttribute('data-zone') || '').split(',').filter(Boolean);
        var form = box.querySelector('.ge-dlhero__form');
        var input = box.querySelector('.ge-dlhero__input');
        var msgIn = box.querySelector('.ge-dlhero__msg--in');
        var msgOut = box.querySelector('.ge-dlhero__msg--out');
        var msgErr = box.querySelector('.ge-dlhero__msg--error');
        if (!form || !input) return;
        function show(el) {
          [msgIn, msgOut, msgErr].forEach(function (m) { if (m) m.hidden = m !== el; });
        }
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          var zip = String(input.value || '').replace(/\D/g, '');
          if (zip.length !== 5) { show(msgErr); return; }
          show(zone.indexOf(zip.slice(0, 2)) !== -1 ? msgIn : msgOut);
        });
        input.addEventListener('input', function () {
          input.value = input.value.replace(/\D/g, '').slice(0, 5);
          if (input.value.length === 5) form.requestSubmit ? form.requestSubmit() : form.dispatchEvent(new Event('submit', { cancelable: true }));
        });
      });
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"]) return;
  try {
    
  (function () {
    function label(count) {
      return count + (count > 1 ? ' articles' : ' article');
    }
    function refreshCount() {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var el = document.querySelector('.ge-cart-head__count');
          if (!el) return;
          if (cart.item_count > 0) {
            el.textContent = label(cart.item_count);
            el.hidden = false;
          } else {
            el.hidden = true;
          }
        })
        .catch(function () {});
    }
    var tries = 0;
    function init() {
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, refreshCount);
        return;
      }
      tries += 1;
      if (tries < 40) setTimeout(init, 250);
    }
    if (document.readyState === 'complete') {
      init();
    } else {
      document.addEventListener('DOMContentLoaded', init);
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
